import {PagingCtrl} from "./PagingCtrl";
import {BaseEntity} from "../entities/BaseEntity";
import { StateService, StateParams } from "@uirouter/angularjs";
import {AdminPagingModel} from "../models/paging/AdminPagingModel";
import {NotificationService} from "../services/NotificationService";

export class AdminPagingCtrl<T extends BaseEntity> extends PagingCtrl<T> {
    public static $inject = ['$scope', '$location', '$state', '$stateParams', '$uibModal', 'PagingModel', 'NotificationService'];

    constructor($scope:any,
                $location: ng.ILocationService,
                stateService: StateService,
                stateParams: StateParams,
                public modal: angular.ui.bootstrap.IModalService,
                public adminPagingModel: AdminPagingModel<T>,
                notificationService: NotificationService) {
        super($scope, $location, stateService, stateParams, adminPagingModel, notificationService);
    }

    init() {
        // Recall pagination
        let pm = this.pagingModel as AdminPagingModel<T>;
        // Only use pagination if URL was not set...
        let paginationPriority:boolean = (this.pagingModel.search === "" &&
            this.pagingModel.page === 1 &&
            this.pagingModel.pageSize === 10 &&
            this.pagingModel.orderColumn === "" &&
            this.pagingModel.orderDirection === "");
        if (paginationPriority && pm.paginationInfoAvailable()) {
            // Use bookmarked pagination information
            pm.recallPagination();
            this.tempSearch = pm.search;
            this.updateLocation();
        }
    }

    protected customActionClick(customAction: string) {
        switch (customAction) {
            case "Batch Print":
                var count = this.adminPagingModel.selectedItems.length;
                var templateType = this.adminPagingModel.printTemplateType();
                var modalInstance: angular.ui.bootstrap.IModalServiceInstance = this.modal.open({
                    animation: true,
                    template: require('../../views/admin.print.html').default,
                    controller: 'PrintCtrl',
                    size: 'lg',
                    resolve: {
                        totalCount: function () {
                            return count;
                        },
                        templateType: function () {
                            return templateType;
                        }
                    }
                });
                modalInstance.result.then((printer) => {
                    this.adminPagingModel.print(printer);
                });
                break;
            case "Export":
                this.stateService.go("admin.export" + this.adminPagingModel.entityName());
                break;
            case "Import":
                this.stateService.go("admin." + this.adminPagingModel.entityName() + "import.fileupload");
                break;
            case "Server Import":
                this.stateService.go("admin.server" + this.adminPagingModel.entityName() + "import.fileupload");
                break;
            default:
                this.adminPagingModel.handleCustomAction(customAction).then(() => {
                    this.getPaged();
                });
        }

    }

    protected addClick(): void {
        this.stateService.go("admin.edit" + this.adminPagingModel.entityName());
        //this.stateService.go("/admin/edit"+this.pagingModel.entityName());
    }

    protected editClick(): void {
        this.stateService.go("admin.edit" + this.adminPagingModel.entityName(), {"id": this.pagingModel.selectedItems[0].id});
    }

    protected deleteClick(): void {
        var ids: number[] = $.map(this.pagingModel.selectedItems, (val, i) => val.id);
        if (confirm("Are you sure you want to delete these " + ids.length + " records?")) {
            this.adminPagingModel.delete(ids).then((data) => {
                this.searchClick();
            })
                .catch((exc) => {
                    this.notificationService.notifyError("Error in deleting items:" + exc);
                });
        }
    }
}
